module.exports = __webpack_public_path__ + "assets/img/attributes.8cb677eb.svg";